import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const BooksScience = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >
        <BooksNavbar textColor="text-black" />

        <div className="relative z-10 min-h-screen flex items-center">
          <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-10 items-center">

            {/* left text */}
            <div className="pt-24 lg:pt-0 text-center lg:text-left">
              <h1
                className="text-5xl md:text-7xl text-black leading-tight mb-8"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Why <br />
                it matters
              </h1>

              <div className="flex items-center w-full max-w-sm mb-8 mx-auto lg:mx-0">
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>

                <span
                  className="px-4 text-[#8c8b5f] text-lg"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  ❖
                </span>

                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              </div>


              <p
                className="text-2xl md:text-3xl text-black leading-relaxed max-w-md mx-auto lg:mx-0"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Executive function is not just about productivity.
                It shapes who we are — our decisions, our relationships,
                our sense of self and our place in the world.
              </p>
            </div>

            {/* Right Brain */}
            {/* <div className="relative flex flex-col items-center justify-center">
              <p
                className="text-3xl md:text-4xl italic text-black mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}           
              >
                Click to explore...
              </p>

              <div className="w-72 h-[1px] bg-[#8c8b5f] mb-8"></div>

              <img
                src="/jigsaw-brain-transparent.png"
                alt="Jigsaw brain"
                className="w-full max-w-[650px]"
              />
            </div> */}

            <div className="flex flex-col items-center pt-16">

              <p
                className="text-3xl md:text-4xl italic text-black mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Click to explore...
              </p>

              <div className="flex items-center w-full max-w-sm mb-8">
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>

                <span
                  className="px-4 text-[#8c8b5f] text-lg"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  ❖
                </span>

                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              </div>

              <div className="relative w-full max-w-[650px]">


                <img
                  src="/jigsaw-brain-transparent.png"
                  alt="Jigsaw brain"
                  className="w-full"
                />

                {/* <a
                href="/books/science/everyday-lapses"
                className="absolute top-[16%] left-[28%] w-[26%] h-[10%] border-2 border-red-500"
                aria-label="Everyday Lapses"
              ></a>

              <a
                href="/books/science/adhd"
                className="absolute top-[30%] left-[52%] w-[20%] h-[10%] border-2 border-blue-500"
                aria-label="ADHD"
              ></a>

              <a
                href="/books/science/concussion"
                className="absolute top-[43%] left-[35%] w-[25%] h-[10%] border-2 border-green-500"
                aria-label="Concussion"
              ></a>

              <a
                href="/books/science/dementia"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Dementia"
              ></a>

              <a
                href="/books/science/parkinsons-disease"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-black-500"
                aria-label="Parkinson's disease"
              ></a>

              <a
                href="/books/science/aging-successfully"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Aging Successfully"
              ></a>

              <a
                href="/books/science/your-brain-on-AI"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Your Brain on AI"
              ></a>

              <a
                href="/books/science/sleep"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Sleep"
              ></a>

              <a
                href="/books/science/your-IQ"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Your IQ"
              ></a>

              <a
                href="/books/science/memory-champion"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="How to Become a Memory Champion"
              ></a>

              <a
                href="/books/science/emotional-regulation"
                className="absolute top-[58%] left-[50%] w-[25%] h-[10%] border-2 border-yellow-500"
                aria-label="Emotional Regulation"
              ></a> */}



                <a
                  href="/books/science/everyday-lapses"
                  className="absolute top-[18%] left-[14%] w-[18%] h-[13%] cursor-pointer"
                  aria-label="Everyday Lapses"
                ></a>

                <a
                  href="/books/science/adhd"
                  className="absolute top-[14%] left-[34%] w-[22%] h-[16%] cursor-pointer"
                  aria-label="ADHD"
                ></a>

                <a
                  href="/books/science/concussion"
                  className="absolute top-[14%] left-[56%] w-[20%] h-[16%] cursor-pointer"
                  aria-label="Concussion"
                ></a>

                <a
                  href="/books/science/dementia"
                  className="absolute top-[17%] left-[76%] w-[18%] h-[16%] cursor-pointer"
                  aria-label="Dementia"
                ></a>

                <a
                  href="/books/science/parkinsons-disease"
                  className="absolute top-[40%] left-[8%] w-[23%] h-[18%] cursor-pointer"
                  aria-label="Parkinson's Disease"
                ></a>

                <a
                  href="/books/science/aging-successfully"
                  className="absolute top-[39%] left-[33%] w-[23%] h-[18%] cursor-pointer"
                  aria-label="Aging Successfully"
                ></a>

                <a
                  href="/books/science/your-brain-on-ai"
                  className="absolute top-[39%] left-[56%] w-[21%] h-[18%] cursor-pointer"
                  aria-label="Your Brain on AI"
                ></a>

                <a
                  href="/books/science/sleep"
                  className="absolute top-[40%] left-[78%] w-[18%] h-[18%] cursor-pointer"
                  aria-label="Sleep"
                ></a>

                <a
                  href="/books/science/your-iq"
                  className="absolute top-[63%] left-[14%] w-[18%] h-[17%] cursor-pointer"
                  aria-label="Your IQ"
                ></a>

                <a
                  href="/books/science/memory-champion"
                  className="absolute top-[65%] left-[33%] w-[26%] h-[19%] cursor-pointer"
                  aria-label="How to Become a Memory Champion"
                ></a>

                <a
                  href="/books/science/emotional-regulation"
                  className="absolute top-[65%] left-[61%] w-[27%] h-[19%] cursor-pointer"
                  aria-label="Emotional Regulation"
                ></a>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default BooksScience;